export enum MemberErrorState {
  UnmatchedInM365 = 0,
}
